export const SHOW = 'modal/SHOW';
export const DISMISS = 'modal/DISMISS';
